export const TYPE = {
  course: "Course",
};
